import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import MilestoneItem from './MilestoneItem';
import styles from './MilestoneSwitcherContent.m.sass';
import { translate as T } from '../../../../utils/translate';
var MilestoneSwitcherContent = function MilestoneSwitcherContent(_ref) {
  var state = _ref.state;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, T('Web.Common.Milestones', 'Milestones'), ' ', /*#__PURE__*/React.createElement("span", {
    className: styles.progress
  }, state.completedMilestones.length, " of ", state.milestones.length, ' ', "completed"))), /*#__PURE__*/React.createElement("div", {
    className: styles.list
  }, state.milestones.map(function (milestone, i) {
    return /*#__PURE__*/React.createElement(MilestoneItem, {
      key: milestone.id,
      milestone: milestone,
      state: state,
      isLast: i === state.milestones.length - 1
    });
  })));
};
export default observer(MilestoneSwitcherContent);
//# sourceMappingURL=MilestoneSwitcherContent.js.map
